import {
  BasicPlanActionResponse,
  RemovePlanFromStatesRequest,
} from '../../types/plans/types';
import { getCustomerIdFromToken } from '../../utils/getCustomerIdFromToken';
import { post } from '../apiService';
import { invalidatePlansListCache } from './listPlans';

export const removePlanFromStates = async (
  body: RemovePlanFromStatesRequest,
): Promise<{ data: BasicPlanActionResponse; loading: boolean }> => {
  const customer = getCustomerIdFromToken();
  if (!customer) {
    throw new Error('Customer Id is not available');
  }
  const url = `/resourceMatrix/insurance/remove_plan_from_states?customerId=${customer}`;
  let loading = true;
  try {
    const responseData = await post(
      url,
      body as unknown as Record<string, unknown>,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    invalidatePlansListCache();
    loading = false;
    return { data: responseData as BasicPlanActionResponse, loading };
  } catch (error) {
    loading = false;
    throw new Error('Failed to remove plan from states');
  }
};
